export default {
  // 서버 주소  
  SERVER: 'https://popbio.ai',  // 운영
  //// SERVER: 'https://baezzang.kr',    // 개발
  // LOCAL_SERVER: 'http://localhost:8090' // 개발_Local
    
  AICC_PROGRAM: 'http://127.0.0.1:9876/mac',
    // 기타 운영 환경 설정...
  };